// const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;
// const IMAGE_BASE_URL = "http://65.1.244.239:3001";
// const IMAGE_URL="http://65.1.244.239:3001/"

import { verifyPayment } from "./Providers/ordersProvider";
import { getAllFilters } from "./Providers/shopProvider";


// const fetchHome = BASE_URL+"/home";
// const fetchBlogs = BASE_URL+"/blog";
// const fetchAbout = BASE_URL+"/aboutus/";
// const postContactUs = `${BASE_URL}/contactus`;
// const fetchFaqs = `${BASE_URL}/faq`;
// const fetchWhyChooseUs = BASE_URL+"/whychooseus/";


// export {IMAGE_BASE_URL,IMAGE_URL,fetchFaqs as fetchFaqs, postContactUs as postContactUs,fetchHome as fetchHome,fetchBlogs as fetchBlogs,fetchAbout,fetchWhyChooseUs};

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
const IMAGE_URL = process.env.REACT_APP_IMAGES_BASE_URL;

const API_ENDPOINTS = {
  home: `${BASE_URL}/home/`,
  blogs: `${BASE_URL}/blog`,
  about: `${BASE_URL}/aboutus/`,
  contactUs: `${BASE_URL}/contactus`,
  faqs: `${BASE_URL}/faq`,
  whyChooseUs: `${BASE_URL}/whychooseus/`,
  addresses:`${BASE_URL}/auth/user`,
  staticFooterFiles:`${BASE_URL}`,
  orders:`${BASE_URL}/order/`,
  verifyPayment: `${BASE_URL}/order/verifypayment`,
  coupons:`${BASE_URL}/coupon/`,
  getAllProducts : `${BASE_URL}/product/getAllActiveProducts`,
  getAllProductsInCategory:`${BASE_URL}/category/getAllProductInCategory/`,
  getProductById:`${BASE_URL}/product/`,
  getAllRelatedProducts:`${BASE_URL}/product/getAllRelatedProducts/`,
  getAllFilters:`${BASE_URL}/product/getFilterOptions`,
  reviews:`${BASE_URL}/review`,
  cart:`${BASE_URL}/cart/`,
  favourite:`${BASE_URL}/favourite/`,
  profile:`${BASE_URL}/auth/user/profile`,
  customSize:`${BASE_URL}/customSize`,
  updateCustomSize:`${BASE_URL}/customsize/`,
  payment:`${BASE_URL}/payment`,
  sizeGuide:`${BASE_URL}/sizeguide`,
  cancelReason:`${BASE_URL}/cancelreason/`,
recaptcha:`${BASE_URL}/recaptcha/`,
};

export { BASE_URL, IMAGE_BASE_URL, IMAGE_URL, API_ENDPOINTS };
